// Switching a plugin on also switches on what it needs, with no dialog. The old page asked "will also install: omni.camera, ..." and people did not know what that meant (2026-10-07).

export function offNeeds(id, registryById, installed) {
  const needed = new Set()
  const visited = new Set()

  function walk(depId) {
    if (visited.has(depId)) return
    visited.add(depId)
    const manifest = registryById.get(depId)
    if (!manifest) return
    const deps = manifest.dependencies ?? {}
    for (const dep of Object.keys(deps)) {
      if (!registryById.has(dep)) continue
      const entry = installed[dep]
      if (!entry || entry.enabled === false) {
        needed.add(dep)
      }
      walk(dep)
    }
  }

  walk(id)
  return Array.from(needed).filter((x) => x !== id)
}

export async function turnOnMany(kernel, ids) {
  const st = kernel.getState()
  const registryById = new Map(st.registry.map((m) => [m.id, m]))

  const toEnable = new Set()
  for (const id of ids) {
    const needs = offNeeds(id, registryById, st.installed)
    for (const n of needs) toEnable.add(n)
    toEnable.add(id)
  }

  const list = Array.from(toEnable).filter((id) => {
    if (!registryById.has(id)) return false
    const entry = st.installed[id]
    return !entry || entry.enabled === false
  })

  for (const id of list) {
    if (!st.installed[id]) {
      kernel.store.install(registryById.get(id))
    }
    kernel.store.setEnabled(id, true)
  }

  if (list.length > 0) {
    await kernel.restart()
  }

  return list.map((x) => registryById.get(x).name)
}

export async function turnOnWithNeeds(kernel, id) {
  const names = await turnOnMany(kernel, [id])
  const st = kernel.getState()
  const registryById = new Map(st.registry.map((m) => [m.id, m]))
  const ownName = registryById.get(id)?.name
  return names.filter((n) => n !== ownName)
}
